import ButtonLink from 'components/ButtonLink';
import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { EntityId, JobType } from 'services/entities/types';
import { AppState } from 'services/types';
import { selectEntityDefaultJobs } from 'services/userEntityAssignments/selectors';
import get from 'lodash.get';

interface OwnProps {
    fieldName: string;
    entityId: EntityId;
    change: Function;
}

interface JobAssignment {
    jobType: JobType;
    assignedUsers: string[];
}

interface ConnectedProps {
    entityDefaultJobs: JobAssignment[];
}

type Props = OwnProps & ConnectedProps;

export class AssignDefaultStaffMembersLinkComponent extends React.PureComponent<Props> {
    render(): React.ReactElement {
        const { change, fieldName, entityDefaultJobs } = this.props;

        return (
            <ButtonLink
                buttonProps={{
                    primary: true,
                    type: 'button'
                }}
                onClick={(): void => {
                    const jobs = { jobs: entityDefaultJobs };
                    const value = get(jobs, fieldName);

                    change(fieldName, value);
                }}
            >
                Assign default staff members
            </ButtonLink>
        );
    }
}

const mapStateToProps = createStructuredSelector<
    AppState,
    OwnProps,
    ConnectedProps
>({
    entityDefaultJobs: selectEntityDefaultJobs
});

export default connect(mapStateToProps)(AssignDefaultStaffMembersLinkComponent);
